import React, { useState } from 'react';
import { Box, Container, Typography, Tabs, Tab } from '@mui/material';
import Layout from '../../components/Layout';
import { WorkoutLogger } from './components/WorkoutLogger';
import { GymAnalytics } from './components/GymAnalytics';
import { ExerciseManager } from './components/ExerciseManager';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import BarChartIcon from '@mui/icons-material/BarChart';
import ListAltIcon from '@mui/icons-material/ListAlt';

export const GymTracker: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'logger' | 'analytics' | 'manager'>('logger');
  const todayStr = new Date().toLocaleDateString('sv-SE'); // Safe YYYY-MM-DD local timezone format
  const [selectedDateStr, setSelectedDateStr] = useState(todayStr);

  const handleLogSaved = () => {
    // Optional placeholder for future global state refresh trigger
  };

  return (
    <Layout>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box sx={{ mb: 4, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, gap: 2 }}>
          <Box>
            <Typography variant="h3" sx={{ fontWeight: 'black', color: 'primary.main', tracking: -1, mb: 1 }}>
              Gym Tracker
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Log workouts, track your estimated 1-Rep Max, training volume, and manage custom exercises!
            </Typography>
          </Box>

          <Tabs
            value={activeTab}
            onChange={(_e, val) => setActiveTab(val)}
            textColor="primary"
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              width: { xs: '100%', md: 'auto' },
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 3,
              p: 0.5,
              backgroundColor: 'background.paper',
              '& .MuiTabs-indicator': {
                borderRadius: 2,
                height: '100%',
                opacity: 0.15,
              },
              '& .MuiTabs-flexContainer': {
                flexWrap: { xs: 'nowrap', md: 'nowrap' },
              }
            }}
          >
            <Tab
              value="logger"
              label="Workout Logger"
              icon={<FitnessCenterIcon />}
              iconPosition="start"
              sx={{ minHeight: 'auto', fontWeight: 'bold', borderRadius: 2, textTransform: 'none' }}
            />
            <Tab
              value="analytics"
              label="Analytics"
              icon={<BarChartIcon />}
              iconPosition="start"
              sx={{ minHeight: 'auto', fontWeight: 'bold', borderRadius: 2, textTransform: 'none' }}
            />
            <Tab
              value="manager"
              label="Exercises"
              icon={<ListAltIcon />}
              iconPosition="start"
              sx={{ minHeight: 'auto', fontWeight: 'bold', borderRadius: 2, textTransform: 'none' }}
            />
          </Tabs>
        </Box>

        <Box sx={{ mt: 2 }}>
          {activeTab === 'logger' && (
            <WorkoutLogger
              selectedDateStr={selectedDateStr}
              setSelectedDateStr={setSelectedDateStr}
              onLogSaved={handleLogSaved}
            />
          )}
          {activeTab === 'analytics' && <GymAnalytics />}
          {activeTab === 'manager' && <ExerciseManager />}
        </Box>
      </Container>
    </Layout>
  );
};

export default GymTracker;
